import { Link } from "react-router-dom";
import { FileText, Github } from "lucide-react";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-zinc-100">
      <header className="sticky top-0 z-40 bg-[#1c1c1f] grain border-b border-orange-500/20">
        <div className="max-w-6xl mx-auto px-5 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group" data-testid="logo-home-link">
            <div className="w-9 h-9 rounded-lg bg-orange-500 flex items-center justify-center shadow-lg shadow-orange-500/30 group-hover:scale-105 transition-transform">
              <FileText className="w-5 h-5 text-white" strokeWidth={2.5} />
            </div>
            <div className="leading-none">
              <div className="font-display font-extrabold text-white text-lg tracking-tight">
                SINTEGRA<span className="text-orange-500">.MG</span>
              </div>
              <div className="text-[11px] text-zinc-400 font-mono mt-0.5">Gerador Fiscal · ERP-SaaS</div>
            </div>
          </Link>
          <div className="flex items-center gap-2 text-zinc-400 text-xs font-mono">
            <span className="w-2 h-2 rounded-full bg-emerald-400 pulse-dot" />
            Sincronizado
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-5 py-8">{children}</main>
      <footer className="max-w-6xl mx-auto px-5 py-8 text-center text-xs text-zinc-400">
        Convênio ICMS 57/95 · Registros 10, 11, 50, 54, 75, 90 · Minas Gerais
      </footer>
    </div>
  );
}
